import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  allHelp: [],
  helpDetails: null,
  allContactMessages: [],
  contactMessageDetails: null,
  loading: false,
  error: null,
  pagination: null
}

const helpSlice = createSlice({
  name: 'help',
  initialState,
  reducers: {
    getAllHelpRequest: (state) => {
      state.loading = true
      state.error = null
    },
    getAllHelpSuccess: (state, action) => {
      state.loading = false
      state.error = null
      
      if (action.payload && typeof action.payload === 'object') {
        if (action.payload.data && Array.isArray(action.payload.data)) {
          state.allHelp = action.payload.data
          state.pagination = action.payload.pagination || null
        }
        else if (Array.isArray(action.payload)) {
          state.allHelp = action.payload
          state.pagination = null
        }
        else {
          state.allHelp = action.payload.faqs || action.payload.data || []
          state.pagination = action.payload.pagination || null
        }
      } else {
        state.allHelp = []
        state.pagination = null
      }
    },
    getAllHelpFail: (state, action) => {
      state.loading = false
      state.error = action.payload
      state.allHelp = []
    },

    getHelpDetailsRequest: (state) => {
      state.loading = true
      state.error = null
    },
    getHelpDetailsSuccess: (state, action) => {
      state.loading = false
      state.error = null
      state.helpDetails = action.payload
    },
    getHelpDetailsFail: (state, action) => {
      state.loading = false
      state.error = action.payload
      state.helpDetails = null
    },

    createHelpRequest: (state) => {
      state.loading = true
      state.error = null
    },
    createHelpSuccess: (state, action) => {
      state.loading = false
      state.error = null
      
      const newFaq = action.payload
      if (newFaq && newFaq._id) {
        state.allHelp = [newFaq, ...state.allHelp]
      }
    },
    createHelpFail: (state, action) => {
      state.loading = false
      state.error = action.payload
    },

    updateHelpRequest: (state) => {
      state.loading = true
      state.error = null
    },
    updateHelpSuccess: (state, action) => {
      state.loading = false
      state.error = null
      
      const updatedFaq = action.payload
      if (updatedFaq && (updatedFaq._id || updatedFaq.helpId)) {
        const faqId = updatedFaq._id || updatedFaq.helpId
        const index = state.allHelp.findIndex(faq => faq._id === faqId)
        
        if (index !== -1) {
          state.allHelp[index] = {
            ...state.allHelp[index],
            ...updatedFaq,
            _id: faqId
          }
        }
      }
    },
    updateHelpFail: (state, action) => {
      state.loading = false
      state.error = action.payload
    },

    deleteHelpRequest: (state) => {
      state.loading = true
      state.error = null
    },
    deleteHelpSuccess: (state, action) => {
      state.loading = false
      state.error = null
      
      const deletedInfo = action.payload
      if (deletedInfo && deletedInfo.helpId) {
        state.allHelp = state.allHelp.filter(faq => faq._id !== deletedInfo.helpId)
      }
    },
    deleteHelpFail: (state, action) => {
      state.loading = false
      state.error = action.payload
    },

    getAllContactMessagesRequest: (state) => {
      state.loading = true
      state.error = null
    },
    getAllContactMessagesSuccess: (state, action) => {
      state.loading = false
      state.error = null
      
      if (action.payload && typeof action.payload === 'object') {
        if (action.payload.data && Array.isArray(action.payload.data)) {
          state.allContactMessages = action.payload.data
          state.pagination = action.payload.pagination || null
        }
        else if (Array.isArray(action.payload)) {
          state.allContactMessages = action.payload
          state.pagination = null
        }
        else {
          state.allContactMessages = action.payload.messages || action.payload.data || []
          state.pagination = action.payload.pagination || null
        }
      } else {
        state.allContactMessages = []
        state.pagination = null
      }
    },
    getAllContactMessagesFail: (state, action) => {
      state.loading = false
      state.error = action.payload
      state.allContactMessages = []
    },

    getContactMessageDetailsRequest: (state) => {
      state.loading = true
      state.error = null
    },
    getContactMessageDetailsSuccess: (state, action) => {
      state.loading = false
      state.error = null
      state.contactMessageDetails = action.payload
    },
    getContactMessageDetailsFail: (state, action) => {
      state.loading = false
      state.error = action.payload
      state.contactMessageDetails = null
    },

    updateContactMessageStatusRequest: (state) => {
      state.loading = true
      state.error = null
    },
    updateContactMessageStatusSuccess: (state, action) => {
      state.loading = false
      state.error = null
      
      const updatedMessage = action.payload
      if (updatedMessage && (updatedMessage._id || updatedMessage.messageId)) {
        const messageId = updatedMessage._id || updatedMessage.messageId
        const index = state.allContactMessages.findIndex(message => message._id === messageId)
        
        if (index !== -1) {
          state.allContactMessages[index] = {
            ...state.allContactMessages[index],
            ...updatedMessage,
            _id: messageId
          }
        }

        if (state.contactMessageDetails && state.contactMessageDetails._id === messageId) {
          state.contactMessageDetails = {
            ...state.contactMessageDetails,
            ...updatedMessage
          }
        }
      }
    },
    updateContactMessageStatusFail: (state, action) => {
      state.loading = false
      state.error = action.payload
    },

    clearHelpError: (state) => {
      state.error = null
    },
    
    clearHelpDetails: (state) => {
      state.helpDetails = null
    },

    clearContactMessageDetails: (state) => {
      state.contactMessageDetails = null
    },

    resetHelpState: (state) => {
      return initialState
    }
  }
})

export const {
  getAllHelpRequest,
  getAllHelpSuccess,
  getAllHelpFail,
  getHelpDetailsRequest,
  getHelpDetailsSuccess,
  getHelpDetailsFail,
  createHelpRequest,
  createHelpSuccess,
  createHelpFail,
  updateHelpRequest,
  updateHelpSuccess,
  updateHelpFail,
  deleteHelpRequest,
  deleteHelpSuccess,
  deleteHelpFail,
  getAllContactMessagesRequest,
  getAllContactMessagesSuccess,
  getAllContactMessagesFail,
  getContactMessageDetailsRequest,
  getContactMessageDetailsSuccess,
  getContactMessageDetailsFail,
  updateContactMessageStatusRequest,
  updateContactMessageStatusSuccess,
  updateContactMessageStatusFail,
  clearHelpError,
  clearHelpDetails,
  clearContactMessageDetails,
  resetHelpState
} = helpSlice.actions

export default helpSlice.reducer